import { atom } from 'recoil';

export const toggleSspModels = atom({
    key: 'shared_toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isTargetsOpen: false,
        isHealthCheckOpen: false,
        isNonPrivilegedADGroupOpen: false,
        isApplicationOpen: false,
        isVmConfigOpen: false,
        isNodePodConfigOpen: false,
    },
});

export const orderId = atom({
    key: 'shared_orderId',
    default: '',
});

export const sspSubmitOrder = atom({
    key: 'shared_sspOrder',
    default: {
        capacityMode: 'On-Demand',
        encryption: 'Default',
        timeToLive: 'Enabled',
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time cost',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'per item per month',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        roleAssignmentRequired: 'No',
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const costEstimateState = atom({
    key: 'shared_costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'shared_isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});
export const isAppShortNameExist = atom({
    key: 'shared_isAppShortNameExist',
    default: false,
});
export const isPrivilegedAdGroupValid = atom({
    key: 'shared_isPrivilegedAdGroupValid',
    default: false,
});
export const isTargetsConfigFullfilled = atom({
    key: 'shared_isTargetsConfigFullfilled',
    default: false,
});

export const isHealthCheckConfigFullfilled = atom({
    key: 'shared_isHealthConfigFullfilled',
    default: false,
});

export const isVmConfigFulfilled = atom({
    key: 'shared_isVmConfigFulfilled',
    default: false,
});

export const isNodePodConfigFulfilled = atom({
    key: 'shared_isNodePodConfigFulfilled',
    default: false,
});

export const isNonPrivilegedADGroupValid = atom({
    key: 'shared_isNonPrivilegedADGroupValid',
    default: false,
});

export const CurrentServerDetails = atom({
    key: 'shared_CurrentServerDetails',
    default: null,
});
export const toggleCurrentServer = atom({
    key: 'shared_toggleCurrentServer',
    default: false,
});
export const isCostcenterValid = atom({
    key: 'shared_isCostcenterValid',
    default: false,
});
export const isConfigDiskFulfilled = atom({
    key: 'shared_isConfigDiskFulfilled',
    default: false,
});
export const isDataDiskLoaded = atom({
    key: 'shared_isDataDiskLoaded',
    default: false,
});
export const defaultOsDiskType = atom({
    key: 'shared_defaultOsDiskType',
    default: undefined,
});
